import { runClientComponent } from '../../_common/client/client-component-runner';
import { TopInfoComponent } from './top-info.component';

runClientComponent({ TopInfoComponent });
